import { useTheme } from '../../../../../../hooks/useTheme';
import styles from '../Fetch.module.css';
import { FetchOfferBar } from './FetchOfferBar';
import { FetchOfferPanel } from './FetchOfferPanel';
import { FetchPlanSelect } from './FetchPlanSelect';
import { FetchPlanScreenMobile } from './FetchPlanScreenMobile';
import type {
  FetchPetFormValues,
  FetchQuoteResult,
  FetchSelectInput,
} from '../types';

type PlanSelection = Omit<FetchSelectInput, 'cartId' | 'prospectPetId'>;

interface FetchPlanScreenProps {
  quote: FetchQuoteResult;
  petInfo: FetchPetFormValues | null;
  onSelect: (selection: PlanSelection, monthlyPrice?: number) => void;
  onEdit: () => void;
  loading?: boolean;
  isMobile?: boolean;
}

export function FetchPlanScreen({
  quote,
  petInfo,
  onSelect,
  onEdit,
  loading,
  isMobile,
}: FetchPlanScreenProps) {
  const theme = useTheme();

  if (isMobile) {
    return (
      <FetchPlanScreenMobile
        quote={quote}
        petInfo={petInfo}
        onSelect={onSelect}
        onEdit={onEdit}
        loading={loading}
      />
    );
  }

  const rootClass = styles.petScreen;

  return (
    <div
      className={rootClass}
      style={{ fontFamily: theme.bodytextDefaultNone?.fontFamily }}
    >
      {!isMobile && <FetchOfferBar />}
      <div className={styles.petBody}>
        <FetchOfferPanel isMobile={isMobile} />
        <FetchPlanSelect
          quote={quote}
          petInfo={petInfo}
          onSelect={onSelect}
          onEdit={onEdit}
          loading={loading}
          isMobile={isMobile}
        />
      </div>
    </div>
  );
}
